import { constants } from "../../../constants";

export default class SoundOff {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    SYN_handler(payload) {
        if (payload.data && payload.data.level && payload.data.level === 0) {
            this.gb.emitters.emit.web.soundOff();
        } else {
            this.gb.emitters.emit.web.soundOn();
        }
    }

    ENDOR_handler(payload) {
        if (payload.mute !== undefined) {
            if (payload.mute) {
                this.gb.emitters.emit.web.soundOff();
            } else {
                this.gb.emitters.emit.web.soundOn();
            }
        }
    }

    EYECON_handler(payload){
        if (payload && typeof payload.enable === 'boolean'){
            if (payload.enable === false){
                this.gb.emitters.emit.web.soundOff();
            } else {
                this.gb.emitters.emit.web.soundOn();
            }
        }
    }

    HABANERO2_handler(payload) {
        if (payload && typeof payload.value === 'boolean') {
            if (payload.value === false) {
                this.gb.emitters.emit.web.soundOff();
            } else {
                this.gb.emitters.emit.web.soundOn();
            }
        }
    }

    OAKS_handler(payload){
        if (payload && typeof  payload.data?.is_enabled ==='boolean'){
            if (!payload.data.is_enabled){
                this.gb.emitters.emit.web.soundOff();
            } else {
                this.gb.emitters.emit.web.soundOn();
            }
        }
    }

    _default() {
        this.gb.emitters.emit.web.soundOff();
        if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable) {
            this.gb.api.modules.superWheel.soundOff();
        }
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.F1X2:
                event["audio-disable"] = this._default;
                break;
            case constants.EDICT:
                event["audioDisabled"] = this._default;
                break;
            case constants.GSPOKER:
           // case constants.GSBINGO:
                event["soundOff"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["SOUND_MUTE"] = this._default;
                break;
            case constants.SYN:
                event["g2p.setVolume"] = this.SYN_handler;
                break;
            case constants.ISOFT:
                event["SOUNDS_MUTED"] = this._default;
                break;  
            case constants.WD:
                event["WGEAPI.soundOff"] = this._default;
                break;
            case constants.WZD:
                event["soundOff.parent"] = this._default;
                break;
            case constants.ENDOR:
                event["settingsChanged"] = this.ENDOR_handler;
                break;
            case constants.EDIG:
                event["toggleSound"] = this._default;
                break;
            case constants.EYE:
                event["updateVolume"] = this.EYECON_handler;
                break;
            case constants.HNR:
                event["audioToggle"] = this.HABANERO2_handler;
                break;
            case constants.OAK:
                event["sound_changed"] = this.OAKS_handler;
                break;
            default:
                event["soundOff"] = this._default;
        }

        return event;
    }
}
